import { BehaviorSubject, Observable } from 'rxjs';
import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { LoginAccess, LoginAccessFilter } from './loginAccess';
import { catchError, finalize } from 'rxjs/operators';

import { ManageUsersService } from '../services/manageUsers.service';
import { of } from 'rxjs';

export class LoginAccessDataSource implements DataSource<LoginAccess> {

    private usersSubject = new BehaviorSubject<LoginAccess[]>([]);
    private loadingSubject = new BehaviorSubject<boolean>(false);
    private totalSubject = new BehaviorSubject<number>(0);

    // eslint-disable-next-line @typescript-eslint/member-ordering
    public loading$ = this.loadingSubject.asObservable();
    // eslint-disable-next-line @typescript-eslint/member-ordering
    public totalItems$ = this.totalSubject.asObservable();

    constructor(private service: ManageUsersService) { }

    connect(_collectionViewer: CollectionViewer): Observable<LoginAccess[]> {
        return this.usersSubject.asObservable();
    }

    disconnect(_collectionViewer: CollectionViewer): void {
        this.usersSubject.complete();
        this.loadingSubject.complete();
        this.totalSubject.complete();
    }

    loadLogins(filter = new LoginAccessFilter()): void {

        this.loadingSubject.next(true);

        this.service.getLogins(filter).pipe(
            catchError(() => of([])),
            finalize(() => this.loadingSubject.next(false))
        ).subscribe(data => {
            if (data && data.content) {
                this.usersSubject.next(data.content as LoginAccess[]);
                this.totalSubject.next(data.totalElements as number);
            } else if (data) {
                this.usersSubject.next(data as LoginAccess[]);
                this.totalSubject.next(data.length as number);
            } else {
                this.usersSubject.next([]);
                this.totalSubject.next(0);
            }
        });
    }
}
